import React from 'react';
import styled from 'styled-components';
import { theme, minBp } from '@triumph/shared';

const DummyHeader = styled.header`
  background-color: black;
  height: 60px;

  @media ${minBp('tabletLarge')} {
    height: 80px;
  }

  @media (min-width: 1366px) {
    height: 70px;
  }
`;

export default DummyHeader;
